<template>
    <div class="project-container">
        <div class="top-title">
            <h2>宁夏彭阳县2024年冷凉蔬菜数字农业示范基地项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2024年开始实施宁夏彭阳县2024年冷凉蔬菜数字农业示范基地项目，以数字技术赋能高寒地区特色种植，建成200亩智能化冷凉蔬菜生产基地。通过部署多参数环境监测站、精准水肥灌溉终端、可视化管理系统，实现温棚环境动态优化、育苗-种植-采收全周期数字化管控，人工成本降低25%，水肥效率提升35%，亩均增产20%。
                    </p>
                    <p>
                        项目由我公司自主研发技术全程支撑，成为西北高海拔冷凉蔬菜产业升级标杆，带动区域农业产值增长超15%，助力彭阳县打造“数字+冷凉经济”融合发展新模式。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/lltwo.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产智能放风机
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/llthree.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司保温被智能地锁
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/llfour.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产迷雾打药系统
                    </p>

                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/MainTypicalcase/llone.png')

        }
    }
}
</script>
